/*

A simple jQuery plugin to make quickshop work on your Estee Lauder page of choice

NOTES:
You must have the quicklook mustache template included in your project.
~/drupal/drupal-7.9/sites/esteelauder/modules/custom/esteelauder_product/templates/quickshop_v1/quickshop.mustache
Here it is as of 7/17/14 in case you want to manually insert it: http://pastebin.com/raw.php?i=qR1KmEbk

Feel free to modify this if your project has specific needs
*/

(function ($) {
  'use strict';

  $.fn.quickshop = function () {

    // Basic checking if everything we need exists otherwise break out or say something
    if (typeof generic === 'undefined') {
      console.log('generic object not available: quickshop will not work');
      return;
    }

    if ($('.inline-template[path="quickshop"]').length === 0) {
      console.log('A template where path="quickshop" does not exist, quickshop will not work without it');
    }

    var product_ids = [],
      elements = $(this);

    // Build list of product ids
    // NOTE: each quickshop <a> should have a data-product="PROD###" where ### is the specific product ID
    // If not it will attempt to parse the product url ex url : /product/12883/6600/Product-Catalog/Makeup/Accessories/Brushes/Concealer-Brush
    elements.each(function () {
      if ($(this).data('product')) {
        product_ids.push($(this).data('product'));
      } else {
        var pathname = this.pathname;
        if (pathname.length > 1) {
          if (pathname.charAt(0) != '/') {
            pathname = '/' + pathname;
          }
          product_ids.push('PROD' + pathname.split('/')[3]);
        } else {
          console.log('No proper data-product value found or properly formatted href found! Quickshop will not work.');
          return false;
        }
      }
    });

    // Run the fetch for all required fields for quickshop
    generic.jsonrpc.fetch({
      method: 'prodcat',
      params: [{
        products: product_ids,
        sku_fields: [
          'HEX_VALUE_STRING',
          'INVENTORY_STATUS',
          'LARGE_IMAGE',
          'MEDIUM_IMAGE',
          'XL_SMOOSH',
          'PRICE',
          'PRODUCT_ID',
          'PRODUCT_SIZE',
          'SHADENAME',
          'SKU_BASE_ID',
          'SKU_ID',
          'XL_IMAGE',
          'formattedPrice'
        ],
        product_fields: [
          'ATTRIBUTE_DESC_2',
          'ATTRIBUTE_LABEL_1',
          'ATTRIBUTE_LABEL_2',
          'PRODUCT_DETAILS_MOBILE',
          'DEFAULT_CAT_ID',
          'DISPLAY_STATUS',
          'FAMILY_CODE',
          'MPP_DESC_1',
          'MPP_DESC_2',
          'PRODUCT_ID',
          'PROD_RGN_NAME',
          'PROD_RGN_SUBHEADING',
          'RATING_IMAGE',
          'SHORT_DESC',
          'TOTAL_REVIEW_COUNT',
          'priceRange',
          'shaded',
          'sized',
          'skus',
          'url',
          'MISC_FLAG',
          'AVERAGE_RATING'
        ]
      }],
      onSuccess: function (results) {
        var product_results = results.getValue().products;
        // Simple 1:1 bind of product data to buttons
        elements.each(function (index) {
          $(this).click(function (e) {
            e.preventDefault();
            // Launch the quickshop
            site.quickshop(product_results[index]);
          });
        });
      },
      onFail: function (error) {
        console.log('QUICKSHOP FAILURE: ', error);
      }
    });
  }; // Plugin END
})(jQuery);

(function ($) {
  Drupal.behaviors.quickshop = {
    attach: function (context, settings) {
      $('.field-content', context).once('quickshop', function () {
        // init Quickshop functionality.
        $('a.quick_shop').quickshop();
      });
    }
  };
})(jQuery);
